import Image from "next/image";
import type { FC } from "react";
import { GoBell } from "react-icons/go";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { IoClose, IoWarningOutline } from "react-icons/io5";
import type { SpecialComponents } from "react-markdown/lib/ast-to-react";
import type { NormalComponents } from "react-markdown/lib/complex-types";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";

import Images from "styles/image-library";
import { isExternalLink } from "utils/is-external-link";

const commonComponents: Partial<
  Omit<NormalComponents, keyof SpecialComponents>
> = {
  a: ({ children, href }) => (
    <a
      href={href}
      target={isExternalLink(href) ? "_blank" : undefined}
      rel={isExternalLink(href) ? "noopener noreferrer" : undefined}
      className="inline-flex gap-1 items-center text-white no-underline hover:underline"
    >
      {children}
      {!isExternalLink(href) ? (
        <HiOutlineArrowNarrowRight className="w-5 h-5" />
      ) : (
        <Image
          src={Images.icons_external_link_white}
          width={12}
          height={12}
          className="my-0"
          alt="External link symbol"
        />
      )}
    </a>
  ),
  strong: ({ children }) => <strong className="text-white">{children}</strong>,
};

export interface CalloutBannerProps {
  scheme: "info" | "warning";
  message: string;
  close: () => void;
}

export const CalloutBanner: FC<CalloutBannerProps> = ({
  scheme,
  message,
  close,
}) => {
  return (
    <div
      className={`relative lg:max-h-[32px] w-full px-4 py-1 md:p-4 ${
        scheme === "warning" ? "bg-warning-text" : "bg-primary"
      } text-white flex gap-2 justify-center items-center`}
    >
      {scheme === "warning" ? (
        <IoWarningOutline className="text-caution-text w-5 h-5" />
      ) : (
        <GoBell className="text-info-text min-w-[20px] w-5 h-5" />
      )}
      <ReactMarkdown className="prose text-white" components={commonComponents}>
        {message}
      </ReactMarkdown>
      <button type="button" className="absolute right-0 pr-2" onClick={close}>
        {}
        <IoClose />
      </button>
    </div>
  );
};
